export default class MenuItem {
  constructor(label, uiAction, uiRoute) {
    this.label = label;
    this.setUiAction(uiAction);
    this.setUiRoute(uiRoute);
    this.children = [];
  }

  setUiAction = (uiAction) => {
    this.uiAction = uiAction;
    this.uiAction.setMenuItem(this);
  }

  setParent = (parentMenuItem) => {
    this.parentMenuItem = parentMenuItem;
  }

  addChild = (childMenuItem) => {
    this.children.push(childMenuItem);
    childMenuItem.setParent(this);
  }

  setUiRoute = (uiRoute) => {
    if(uiRoute) {
      this.uiRoute = uiRoute;
      this.uiRoute.uiPage.setLinkedUiMenu(this);
    }
  }

  hasChildren = () => {
    return this.children.length > 0;
  }

  addChildMenus = (...childMenuItems) => {
    childMenuItems.forEach((menuItem) => {
      this.addChild(menuItem);
    });
    return this;
  }
}
